import { useState } from 'react';

/**
 * @param {string} key
 */
export const getItem = key => {
  if (document && typeof document !== 'undefined') {
    return document.cookie.split(`; `).reduce((total, currentCookie) => {
      const item = currentCookie.split(`=`);
      const storedKey = item[0];
      const storedValue = item[1];
      return key === storedKey ? decodeURIComponent(storedValue) : total;
    }, ``);
  }

  return undefined;
};

/**
 *
 * @param {string} key
 * @param {string|undefined} value
 * @param {number} numberOfDays
 */
const setItem = (key, value, numberOfDays) => {
  const now = new Date();

  // set the time to be now + numberOfDays
  now.setTime(now.getTime() + numberOfDays * 60 * 60 * 24 * 1000);
  let cookieStr = `${key}=${value}; expires=${now.toUTCString()}; path=/`;

  if (window.location.hostname === 'www.farmersfridge.com') {
    cookieStr += '; domain=farmersfridge.com';
  }

  if (document && typeof document !== 'undefined') {
    document.cookie = cookieStr;
  }
};

/**
 *
 * @param {String} key The key to store our data to
 * @param {String=} defaultValue The default value to return in case the cookie doesn't exist
 * @returns {Array<*> & { 0: string|undefined, 1: (value: string, numberOfDays: number) => void, length: 2 }}
 */
export default function useCookie(key, defaultValue) {
  if (typeof document === 'undefined') {
    return ['', () => {}];
  }

  const getCookie = () => getItem(key) || defaultValue;
  const [cookie, setCookie] = useState(getCookie());

  /**
   *
   * @param {string|undefined} value
   * @param {number} numberOfDays
   */
  const updateCookie = (value, numberOfDays) => {
    setCookie(value);
    setItem(key, value, numberOfDays);
  };

  return [cookie, updateCookie];
}
